import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Where Stripe Checkout comes back to.
 *
 * The backend builds the Checkout session with this as its success/cancel URL and appends
 * `?status=success|cancelled` (docs/billing-api.md), so the route has to exist or every purchase
 * lands on a 404 after the customer has already paid.
 *
 * It deliberately renders nothing. All it does is forward into the Billing tab, which is where the
 * settling banner and the polling live — a second page that also knew how to poll and explain the
 * webhook delay would be the same logic twice. `replace` keeps the throwaway URL out of the history,
 * so Back returns to the app rather than to Stripe.
 *
 * Only `status` is read, because that is the only param Stripe is documented to send. The purchase's
 * member and plan are not knowable here, which is why the tab polls the whole org's billing status
 * rather than waiting for one specific row to change.
 */
export function BillingReturn() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') === 'success' ? 'success' : 'cancelled';

  return <Navigate to={`/studio/org-admin?tab=billing&checkout=${status}`} replace />;
}

export default BillingReturn;
